import type { JVSIcons } from '@mairistem/composants';
import type { UserRole } from '@mairistem/finances-utils';
import dayjs from 'dayjs';
import React from 'react';
import NextPeriodeModal from '../../components/simulation/Outils/Periode/NextPeriodeModal';
import TypePeriode from '../../constants/simulation/typePeriode';
import type Simulation from '../../interfaces/simulation/simulation';
import BaseOutil from './BaseOutil';

const getPeriodeIcon = (typePeriode: TypePeriode): JVSIcons => {
	switch (typePeriode) {
		case TypePeriode.DEMANDE:
			return 'NotebookPen';
		case TypePeriode.PROPOSE:
			return 'Vote';
		case TypePeriode.VOTE:
			return 'HandCoins';
		default:
			return 'ArrowRightToLine';
	}
};

const getPeriodeTitle = (typePeriode: TypePeriode): string => {
	switch (typePeriode) {
		case TypePeriode.DEMANDE:
			return 'Formuler les propositions budgétaires';
		case TypePeriode.PROPOSE:
			return 'Procéder au vote par l’assemblée';
		case TypePeriode.VOTE:
			return 'Rendre exécutoire le budget';
		case TypePeriode.CA_CFU:
			return 'Valider les restes à réaliser';
		default:
			return '';
	}
};

class NextPeriode extends BaseOutil {
	constructor(typePeriode: TypePeriode) {
		super();
		this.code = 'NEX_PER';
		this.icon = { iconSet: 'Lucide', name: getPeriodeIcon(typePeriode) };
		this.title = getPeriodeTitle(typePeriode);
	}

	isEnabled(userRole: UserRole, simulation: Simulation): boolean {
		return (
			super.isEnabled(userRole, simulation) &&
			!simulation?.transfertCpta &&
			// Si aucune date butoir n'est définie, on peut passer à la période suivante
			(!simulation?.dateButoirDemande ||
				// Si on est en demande et que la date butoir n'est pas depasse, alors on ne peut pas passer en propose
				dayjs(simulation?.dateButoirDemande).isBefore(dayjs()) ||
				simulation?.typePeriode !== TypePeriode.DEMANDE)
		);
	}

	renderModal(
		simulation: Simulation,
		onClose: () => void,
		onValidate: (typePeriode: TypePeriode) => void,
		open: boolean,
	) {
		return (
			<NextPeriodeModal
				onClose={onClose}
				onValidate={onValidate}
				open={open}
				simulation={simulation}
				title={this.title}
			/>
		);
	}
}

export default NextPeriode;
